module.exports = "build/assets/RingsideCondensed-Semi.be0d7a98.woff2";